<template>
    <div class="template">
        <navigation/>
        <div class="content">
            <div class="panel">
                <form @submit="submit" v-if="!success">
                    <div class="title">{{ $t('pages.forgot.title')  }}</div>
                    <div>
                        <label>{{ $t('labels.email') }} *</label>
                        <input ref="email" v-model="email" type="text" :class="error ? 'error' : ''"/>
                        <div class="error" v-if="error">{{ error }}</div>
                    </div>
                    <button>{{ $t('pages.forgot.button') }}</button>
                </form>
                <div id="success" v-if="success">{{ success }}</div>
                <div>
                    <router-link :to="$translationRoute({ name: 'login' })">{{ $t('pages.forgot.login') }}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '@/services/auth'
import logger from '@/services/logger'

export default {
  data () {
    return {
      email: '',
      error: '',
      success: ''
    }
  },
  created () {
    logger.setFields({})
  },
  mounted () {
    this.$refs.email.focus()
  },
  methods: {
    submit (e) {
      // Init
      e.preventDefault()
      this.error = ''

      // Check email
      if (!this.email || this.email === '') {
        this.error = this.$i18n.t('mandatory.email')
        return
      }

      // Forgot
      auth.forgot(this.email)
        .then((data) => {
          // Update success
          this.success = data
        })
        .catch(err => {
          // Process error
          var msg = this.$i18n.t('errors.default')
          if (err.isHTTP) {
            // Update message
            msg = err
          } else {
            // Log
            logger.error(err)
          }

          // Show error
          this.error = msg
        })
    }
  }
}
</script>

<style scoped>

/* Large desktop */
@media (min-width: 1200px) {

    .panel {
        min-width: 35em;
    }

}

/* Portrait tablet to landscape and desktop */
@media (min-width: 768px) and (max-width: 1199px) {

    .panel {
        min-width: 35em;
    }

}

/* Landscape phone to portrait tablet */
@media (min-width: 481px) and (max-width: 767px) {

    .panel {
        min-width: 35em;
    }

}

/* Landscape phones and down */
@media (max-width: 480px) {

    .panel {
        max-width: 75%;
    }

}

.panel {
    margin: 3em 0;
}

form, #success {
    margin: 0 0 3em 0;
    width: 100%;
}

</style>
